import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PortfolioBudgetComponent } from './portfolio-budget.component';

const routes: Routes = [
  {
    path: '',
    component: PortfolioBudgetComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PortfolioBudgetRoutingModule { }
